document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var variantsEl = root.querySelector('[data-pdp-variants]');
  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var idInput = root.querySelector('[data-pdp-id]');
  var optionGroups = root.querySelectorAll('[data-pdp-option]');

  function selectedOptions() {
    var values = [];
    optionGroups.forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      var checked = group.querySelector('input[type="radio"]:checked');
      values[index] = checked ? checked.value : null;
    });
    return values;
  }

  function findVariant(values) {
    return variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === values[index];
      });
    });
  }

  function updateVariant() {
    var variant = findVariant(selectedOptions());
    if (!variant) return;

    if (idInput) idInput.value = variant.id;

    var currentPrice = root.querySelector('[data-pdp-current-price]');
    var comparePrice = root.querySelector('[data-pdp-compare-price]');
    var comparePriceWrap = root.querySelector('[data-pdp-compare-price-wrap]');
    var discount = root.querySelector('[data-pdp-discount]');
    var onSale = variant.compare_at_price > variant.price;

    if (currentPrice) currentPrice.textContent = formatMoney(variant.price);
    if (comparePrice) comparePrice.textContent = formatMoney(variant.compare_at_price || variant.price);
    if (comparePriceWrap) comparePriceWrap.classList.toggle('hidden', !onSale);
    if (discount) {
      if (onSale) {
        var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        discount.textContent = '-' + pct + '%';
      }
      discount.classList.toggle('hidden', !onSale);
    }

    var atcButton = root.querySelector('[data-pdp-atc-button]');
    var atcLabel = root.querySelector('[data-pdp-atc-label]');
    if (atcButton) atcButton.disabled = !variant.available;
    if (atcLabel) atcLabel.textContent = variant.available ? atcLabel.getAttribute('data-available-label') || atcLabel.textContent : atcLabel.getAttribute('data-sold-out-label') || 'Sold Out';

    var stickyPrice = root.querySelector('[data-pdp-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    if (variant.featured_media && window.pdpGallery) {
      var slides = root.querySelectorAll('.pdp-gallery-main [data-media-id]');
      slides.forEach(function (slide, index) {
        if (parseInt(slide.getAttribute('data-media-id'), 10) === variant.featured_media.id) {
          window.pdpGallery.slideTo(index);
        }
      });
    }

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }

    root.dispatchEvent(new CustomEvent('pdp:variant-change', { detail: { variant: variant } }));
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang, {
      style: 'currency',
      currency: root.dataset.currency,
    }).format(cents / 100);
  }

  function initVariants() {
    optionGroups.forEach(function (group) {
      group.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var index = group.getAttribute('data-option-index');
          var summaryValue = root.querySelector('[data-pdp-option-summary-value][data-option-index="' + index + '"]');
          if (summaryValue) summaryValue.textContent = radio.value;

          var additionalValue = root.querySelector('[data-pdp-additional-option-value][data-option-index="' + index + '"]');
          if (additionalValue) additionalValue.textContent = radio.value;

          updateVariant();
        });
      });
    });
  }

  function initQuantity() {
    root.querySelectorAll('[data-pdp-qty]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-qty-input]');
      stepper.querySelector('[data-qty-decrease]').addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value, 10) - 1);
      });
      stepper.querySelector('[data-qty-increase]').addEventListener('click', function () {
        input.value = parseInt(input.value, 10) + 1;
      });
    });
  }

  function initStickyBar() {
    var stickyBar = document.querySelector('[data-pdp-sticky-bar]');
    var mainAtc = root.querySelector('[data-pdp-atc-button]');
    if (!mainAtc || !stickyBar) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.setAttribute('data-visible', String(!entry.isIntersecting));
        });
      },
      { rootMargin: '-72px 0px 0px 0px' }
    );
    observer.observe(mainAtc);

    var stickyAtc = stickyBar.querySelector('[data-pdp-sticky-atc]');
    if (stickyAtc && mainAtc) {
      stickyAtc.addEventListener('click', function () {
        mainAtc.click();
      });

      var syncStickyState = function () {
        stickyAtc.disabled = mainAtc.disabled;
        if (mainAtc.getAttribute('data-loading') === 'true') {
          stickyAtc.setAttribute('data-loading', 'true');
        } else {
          stickyAtc.removeAttribute('data-loading');
        }
      };
      new MutationObserver(syncStickyState).observe(mainAtc, {
        attributes: true,
        attributeFilter: ['data-loading', 'disabled'],
      });
      syncStickyState();
    }
  }

  initVariants();
  initQuantity();
  initStickyBar();
});
